import api from '../api'
import { ERROR, LOADING } from '../constants/globalConstants'
import {
  ADD_PLAYLIST,
  GET_PUBLIC_PLAYLISTS,
  ADD_SONG_TO_PLAYLIST,
  GET_PLAYLIST,
  EDIT_PLAYLIST,
  DELETE_PLAYLIST,
  REMOVE_SONG_FROM_PLAYLIST
} from '../constants/playlistConsants'

export const addPlaylist = (title, isPublic, navigate) => async (dispatch, getState) => {
  try {
    dispatch({
      type: LOADING
    })

    const { userState: { userInfo: { token } } } = getState()
    const config = {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }

    const { data } = await api.post('/playlists/new', { title, isPublic }, config)
    dispatch({
      type: ADD_PLAYLIST,
    })

    navigate(`/playlists/${data._id}`)
  } catch (error) {
    dispatch({
      type: ERROR,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const getPublicPlaylists = () => async dispatch => {
  try {
    dispatch({
      type: LOADING
    })

    const { data } = await api.get('/playlists/public-playlists')
    dispatch({
      type: GET_PUBLIC_PLAYLISTS,
      payload: data
    })
  } catch (error) {
    dispatch({
      type: ERROR,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
    alert('Something went wrong')
  }
}

export const addSongToPlaylist = (playlistId, songId, navigate) => async (dispatch, getState) => {
  try {
    dispatch({
      type: LOADING
    })

    const { userState: { userInfo: { token } } } = getState()
    const config = {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }

    const { data } = await api.put(`/playlists/add-song/${songId}/${playlistId}`, {}, config)
    dispatch({
      type: ADD_SONG_TO_PLAYLIST
    })

    navigate(`/playlists/${data._id}`)
  } catch (error) {
    dispatch({
      type: ERROR,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const getPlaylist = (id) => async dispatch => {
  try {
    dispatch({
      type: LOADING
    })

    const { data } = await api.get(`/playlists/playlist/${id}`)
    dispatch({
      type: GET_PLAYLIST,
      payload: data
    })
  } catch (error) {
    dispatch({
      type: ERROR,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
    alert('Something went wrong')
  }
}

export const editPlaylist = (id, title, isPublic, navigate) => async (dispatch, getState) => {
  try {
    dispatch({
      type: LOADING
    })

    const { userState: { userInfo: { token } } } = getState()
    const config = {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }

    const { data } = await api.put(`/playlists/playlist/${id}`, { title, isPublic }, config)
    dispatch({
      type: EDIT_PLAYLIST,
    })

    navigate(`/playlists/${data._id}`)
  } catch (error) {
    dispatch({
      type: ERROR,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const deletePlaylist = (id, navigate) => async (dispatch, getState) => {
  try {
    if (window.confirm('Are you sure? This CANNOT be undone!')) {
      dispatch({
        type: LOADING,
      })

      const { userState: { userInfo: { token } } } = getState()
      const config = {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }

      await api.delete(`/playlists/playlist/${id}`, config)
      dispatch({
        type: DELETE_PLAYLIST
      })
      navigate('/')
    }
  } catch (error) {
    dispatch({
      type: ERROR,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
    alert('Something went wrong')
  }
}

export const removeSongFromPlaylist = (playlistId, songId, navigate) => async (dispatch, getState) => {
  try {
    dispatch({
      type: LOADING
    })

    const { userState: { userInfo: { token } } } = getState()
    const config = {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }

    const { data } = await api.delete(`/playlists/add-song/${songId}/${playlistId}`, config)
    dispatch({
      type: REMOVE_SONG_FROM_PLAYLIST
    })

    navigate(`/playlists/${data._id}`)
  } catch (error) {
    dispatch({
      type: ERROR,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
    alert('Something went wrong')
  }
}
